module.exports = __webpack_public_path__ + "static/media/20ECE12.07100470.jpg";